import { AddressingConfigurationRuleResponseDto } from '@tiendanube/common';
import { ADDRESSING_RULES_TYPES } from './constants';

export const getEnabledRules = (
  rules: AddressingConfigurationRuleResponseDto[],
): AddressingConfigurationRuleResponseDto[] =>
  rules.filter((rule) => rule.enabled);

export const findRuleByType = (
  rules: AddressingConfigurationRuleResponseDto[],
  type: string,
): AddressingConfigurationRuleResponseDto | undefined =>
  rules.find((rule) => rule.type === type);

export const changeAppRule = (
  rules: AddressingConfigurationRuleResponseDto[],
  appCode?: string,
) =>
  rules.map((rule) =>
    rule.type === ADDRESSING_RULES_TYPES.APP && rule.code !== appCode
      ? { ...rule, enabled: false }
      : rule,
  );

export const changeTiebreakerRule = (
  rules: AddressingConfigurationRuleResponseDto[],
  value: boolean,
  isPriority: boolean,
) =>
  rules.map((rule) =>
    (isPriority && rule.type === ADDRESSING_RULES_TYPES.CD_PROXIMITY) ||
    (!isPriority && rule.type === ADDRESSING_RULES_TYPES.CD_PRIORITY)
      ? { ...rule, enabled: !value }
      : rule,
  );
